// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ItemList_itemList__3aY_p","title":"ItemList_title__3mBa3"};